import { appRoutes } from './appRouteConfig';

export const productNavVisibility = {
	[appRoutes.createTrip]: false,
	[appRoutes.teamEvents]: true,
};
